import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import failIcon from '../images/fail.svg';
import './errorMsg.scss';

const ErrorMsg = (props) => {
  const isFiberAdd = props.variant === 'fiberAdd';

  if (isFiberAdd) {
    return (
      <div className='cg-error-msg cg-error-msg--fiber'>
        <div className='img-wrapper'>
          <Image alt='card-failed' src={failIcon} />
        </div>
        <p className='cg-error-msg__text'>
          {props.message || 'פרטי האשראי שהוזנו לא תקינים'}
        </p>
        <button
          type='button'
          className='cg-error-msg__retry'
          onClick={props.onclickTryAgainBtn}
        >
          ננסה כרטיס אחר?
        </button>
      </div>
    );
  }

  return (
    <div className='cg-error-msg'>
      <p>
        <span className='bold'>הודעת שגיאה לגבי הכרטיס</span>
        <br />
        נסה אולי כרטיס אחר
      </p>
      <BtnSubmit
        isBusiness={false}
        text='נסה שנית'
        onclick={props.onclickTryAgainBtn}
        formid='cg-error-msg'
        isDisplayArrows={false}
      />
    </div>
  );
};

export default ErrorMsg;
